
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from '@/utils/analytics';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view
    trackEvent('page_view', {
      page_location: window.location.href,
      page_path: location.pathname,
      page_title: document.title,
    });

    // Check for UTM parameters from email links
    const urlParams = new URLSearchParams(location.search);
    const utmSource = urlParams.get('utm_source');
    const utmMedium = urlParams.get('utm_medium');
    const utmCampaign = urlParams.get('utm_campaign');
    const utmContent = urlParams.get('utm_content');

    // Track email referrals
    if (utmSource === 'email') {
      trackEvent('email_referral', {
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign,
        utm_content: utmContent,
        page_path: location.pathname,
        referral_type: 'email_click',
      });

      // Track specific email-driven conversions
      if (location.pathname.includes('/confirm') || location.pathname.includes('/verify')) {
        trackEvent('email_conversion', {
          conversion_type: 'email_verification_page',
          utm_campaign: utmCampaign,
          utm_content: utmContent,
        });
      }

      if (location.pathname.includes('/reset-password')) {
        trackEvent('email_conversion', {
          conversion_type: 'password_reset_page',
          utm_campaign: utmCampaign,
          utm_content: utmContent,
        });
      }

      if (location.pathname.includes('/invite') || location.pathname.includes('/join')) {
        trackEvent('email_conversion', {
          conversion_type: 'invitation_page',
          utm_campaign: utmCampaign,
          utm_content: utmContent,
        });
      }
    }

    // Track user engagement based on time spent
    const startTime = Date.now();
    
    return () => {
      const timeSpent = Date.now() - startTime;
      if (timeSpent > 10000) { // Only track if user spent more than 10 seconds
        trackEvent('user_engagement', {
          engagement_time_msec: timeSpent.toString(),
          page_path: location.pathname,
        });
      }
    };
  }, [location]);
};
